import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { connect } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { GET_INSUFFICIENT_PRODUCT_REQUEST } from "../../../../_utils/constants/Customer";

// "Insufficient Materials" widget — lifted verbatim from the original
// Dashboard.jsx (infinite-scroll table). dataScope / userId are accepted now
// so the data fetch can be scoped to the logged-in user in a later task; the
// current behavior is unchanged.
const InsufficientMaterials = ({
  auth: { auth, isAuthenticated },
  customerInfo: { insufficientInventoryData, totalInvCount },
  fetchInsufficientInventory,
  dataScope = "all",
  userId,
}) => {
  const [insufficientInventoryDetails, setInsufficientInventoryDetails] = useState([]);
  const [page, setPage] = useState(20);
  const [hasMore, setHasMore] = useState(true);
  const [isFetchingMore, setIsFetchingMore] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      fetchInsufficientInventory(auth, page);
    }
  }, [auth, isAuthenticated]);

  useEffect(() => {
    if (insufficientInventoryData && insufficientInventoryData.length > 0) {
      setInsufficientInventoryDetails((prev) => {
        const existingJobNos = new Set(prev.map((item) => item.jobNo));
        const newUniqueItems = insufficientInventoryData.filter(
          (item) => !existingJobNos.has(item.jobNo)
        );
        const updatedList = [...prev, ...newUniqueItems];
        if (updatedList.length >= totalInvCount) {
          setHasMore(false);
        }
        setIsFetchingMore(false);
        return updatedList;
      });
    }
  }, [insufficientInventoryData, totalInvCount]);

  // handle fetching of more data
  const fetchMoreData = () => {
    if (isFetchingMore || insufficientInventoryDetails.length >= totalInvCount) {
      setHasMore(false);
      return;
    }
    const nextPage = page + 10;
    setIsFetchingMore(true);
    setPage(nextPage);
    fetchInsufficientInventory(auth, nextPage);
  };

  // handle date formatting
  const handleFormatDate = (installationDate) => {
    const dateObj = new Date(installationDate);
    const month = dateObj.getMonth() + 1;
    const day = dateObj.getDate();
    const year = dateObj.getFullYear();
    return `${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day}-${year}`;
  };

  return (
    <div className="insufficient-materials-widget">
      <h4 className="title">Insufficient Materials</h4>
      <div
        className="insufficient-material-table"
        id="scrollableDiv"
        style={{ maxHeight: 400, overflow: "auto" }}
      >
        <InfiniteScroll
          dataLength={insufficientInventoryDetails.length}
          next={fetchMoreData}
          hasMore={hasMore}
          loader={isFetchingMore ? <h6>Loading more items...</h6> : null}
          scrollableTarget="scrollableDiv"
        >
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th>Date</th>
                <th>Job No</th>
                <th>Product</th>
                <th>Insufficient Quantity</th>
              </tr>
            </thead>
            <tbody>
              {insufficientInventoryDetails.map((data, index) => (
                <tr key={index}>
                  <td>{handleFormatDate(data.createdOn)}</td>
                  <td>{data.jobNo}</td>
                  <td>{data.productName}</td>
                  <td>{parseFloat(data.insufficientQuantity).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </InfiniteScroll>
      </div>
    </div>
  );
};

const mapStateToProps = ({ auth, customerInfo }) => ({ auth, customerInfo });

const mapDispatchToProps = (dispatch) => ({
  fetchInsufficientInventory: (data, paginate) =>
    dispatch({ type: GET_INSUFFICIENT_PRODUCT_REQUEST, data, paginate }),
});

export default connect(mapStateToProps, mapDispatchToProps)(InsufficientMaterials);
